import React from "react";

const FilterOffCanvas = ({
                             id = "offcanvasRight",
                             title = "Filter",
                             children,
                             onClear = () => {},
                             width,
                             rightButton="Apply",
                             leftButton="Clear",
                             onApply = () => {},
                         }) => {
    return (
        <div
            className={`offcanvas offcanvas-end ${width}`}
            tabIndex="-1"
            id={id}
            aria-labelledby={`${id}Label`}
        >
            <div className="offcanvas-header align-items-center border-bottom border-3 border-light">
                <h5 id={`${id}Label`} className="fw-bold">
                    {title}
                </h5>
                <button
                    type="button"
                    className="btn-close text-reset bg-light rounded-circle"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </div>

            <div className="offcanvas-body fw-bold fs-5">
                {children}
            </div>

            <div className="offcanvas-footer border-top p-3">
                <div className="d-flex justify-content-between">
                    <button className="btn btn-outline-primary" data-bs-dismiss="offcanvas" onClick={onClear}>{leftButton}</button>
                    <button className="btn btn-primary" data-bs-dismiss="offcanvas" onClick={onApply}>{rightButton}</button>
                </div>
            </div>
        </div>
    );
};

export default FilterOffCanvas;

